/* global process */
import tenants from "../tenants/index.js";

const LOCAL_TENANT = "floorwalk";
// const LOCAL_TENANT = "hsbrandsasia";

export function getTenant() {
	if (process.env.NODE_ENV === "development") {
		return tenants[LOCAL_TENANT];
	}

	// qc.floorwalk.in      -> floorwalk
	// qc.hsbrandsasia.com  -> hsbrandsasia
	const host = window.location.hostname;
	const tenantKey = host.split(".")[1];

	return tenants[tenantKey] || tenants.floorwalk;
}

// Set the tenant's page title and favicon. The tenant is fixed by the
// hostname, so this runs once at startup (replaces react-helmet, and also
// covers the /login route, which is rendered outside <App>).
export function applyTenantHead(tenant = getTenant()) {
	document.title = `${tenant.name} QC Portal`;

	let icon = document.querySelector("link[rel='icon']");
	if (!icon) {
		icon = document.createElement("link");
		icon.rel = "icon";
		document.head.appendChild(icon);
	}
	icon.type = "image/png";
	icon.href = tenant.favicon;
}